import { Package } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const WhatsIncludedSection = () => {
  const { t } = useTranslation();
  
  const cards = [
    { 
      icon: '📰', 
      title: t('whatsIncluded.cards.0.title'), 
      description: t('whatsIncluded.cards.0.description') 
    },
    { 
      icon: '🧠', 
      title: t('whatsIncluded.cards.1.title'), 
      description: t('whatsIncluded.cards.1.description') 
    },
    { 
      icon: '💡', 
      title: t('whatsIncluded.cards.2.title'), 
      description: t('whatsIncluded.cards.2.description') 
    },
    { 
      icon: '💻', 
      title: t('whatsIncluded.cards.3.title'), 
      description: t('whatsIncluded.cards.3.description') 
    },
    { 
      icon: '✨', 
      title: t('whatsIncluded.cards.4.title'), 
      description: t('whatsIncluded.cards.4.description') 
    }
  ];

  return (
    <div className="mb-16 animate-fade-in">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-newsletter-primary/10 border border-newsletter-primary/20 mb-4">
          <Package className="w-4 h-4 text-newsletter-primary" />
          <span className="text-sm font-medium text-newsletter-primary">
            {t('whatsIncluded.badge')}
          </span>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          {t('whatsIncluded.title')}
        </h2>
        <p className="text-muted-foreground text-lg">
          {t('whatsIncluded.subtitle')}
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
        {cards.map((card, index) => (
          <div
            key={index}
            className="p-6 rounded-2xl border border-newsletter-primary/20 bg-background/50 backdrop-blur-sm hover:border-newsletter-primary/40 hover:shadow-xl transition-all duration-300 group"
          >
            <div className="text-5xl mb-4 group-hover:scale-110 transition-transform duration-300">
              {card.icon}
            </div>
            <h3 className="font-semibold text-base mb-2 text-foreground">
              {card.title}
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {card.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};